export default "__VITE_ASSET__BcG$SWuh__"